import instance from "./axiosInstance";

/** Web batch view; original per-image endpoints remain compatible with the mini-program. */
export const pageDeviceResultBatches = async (params) => {
  const response = await instance.post(
    "/deviceResult/batches/quick-page",
    params,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return response.data;
};

export const countDeviceResultBatches = async (params) => {
  const response = await instance.post("/deviceResult/batches/count", params, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

export const getDeviceResultBatch = async (imageId) => {
  const response = await instance.get(`/deviceResult/batches/${imageId}`);
  return response.data;
};

export const removeDeviceResultBatchImage = async (imageId) => {
  const response = await instance.delete(
    `/deviceResult/batches/image/${imageId}`
  );
  return response.data;
};

/** 当前设备和账号权限范围内有检测记录的日期，不受分页限制。 */
export const getDeviceResultAvailableDates = async (params = {}) => {
  const response = await instance({
    method: "POST",
    url: "/deviceResult/availableDates",
    headers: { "Content-Type": "application/json" },
    data: params,
  });
  return response.data;
};

/**
 * 根据主键ID获取设备结果详细数据
 * @param {Number} id 设备结果ID
 */
export const getDeviceResultById = async (id) => {
  try {
    const response = await instance({
      method: "GET",
      url: `/deviceResult/get/${id}`,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error("获取设备结果详情异常:", error);
    throw error;
  }
};

/**
 * 查询本人拥有的设备检测的历史数据（分页）
 * @param {Object} params { pageNum, pageSize, deviceId? }
 */
export const pageDeviceResultByLogin = async (params) => {
  try {
    const response = await instance({
      method: "POST",
      url: "/deviceResult/page",
      headers: {
        "Content-Type": "application/json",
      },
      data: params,
    });
    return response.data;
  } catch (error) {
    console.error("查询设备结果列表异常:", error);
    throw error;
  }
};

/**
 * 查询所有设备检测的历史数据（管理员可用，分页）
 * @param {Object} params { pageNum, pageSize, deviceId? }
 */
export const pageAllDeviceResult = async (params) => {
  try {
    const response = await instance({
      method: "POST",
      url: "/deviceResult/pageAll",
      headers: {
        "Content-Type": "application/json",
      },
      data: params,
    });
    return response.data;
  } catch (error) {
    console.error("查询所有设备结果列表异常:", error);
    throw error;
  }
};

/**
 * 根据主键删除设备结果
 * @param {Number} id 设备结果ID
 */
export const removeDeviceResult = async (id) => {
  try {
    const response = await instance({
      method: "DELETE",
      url: `/deviceResult/remove/${id}`,
    });
    return response.data;
  } catch (error) {
    console.error("删除设备结果异常:", error);
    throw error;
  }
};
